export class OAuthCodeGenerationUtils {
    /**
     * Generates a cryptographically secure random string
     * of variable length.
     *
     * The returned string is also url-safe.
     *
     * @param {Number} length the length of the random string.
     * @returns {String}
     */
    static randomString(length) {
        const validChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let array = new Uint8Array(length);
        window.crypto.getRandomValues(array);
        array = array.map(x => validChars.charCodeAt(x % validChars.length));
        return String.fromCharCode(...array);
    }

    /**
     * Takes a base64 encoded string and returns a url encoded string
     * by replacing the characters + and / with -, _ respectively,
     * and removing the = (fill) character.
     *
     * @param {String} input base64 encoded string.
     * @returns {String}
     */
    static urlEncodeB64(input) {
        const b64Chars = {'+': '-', '/': '_', '=': ''};
        return input.replace(/[\+\/=]/g, m => b64Chars[m]);
    }

    /**
     * Takes an ArrayBuffer and convert it to Base64 url encoded string.
     * @param {ArrayBuffer} input
     * @returns {String}
     */
    static bufferToBase64UrlEncoded(input) {
        const bytes = new Uint8Array(input);
        return OAuthCodeGenerationUtils.urlEncodeB64(window.btoa(String.fromCharCode(...bytes)));
    }

    /**
     * Returns the sha256 digest of a given message.
     * This function is async.
     *
     * @param {String} message
     * @returns {Promise<ArrayBuffer>}
     */
    static sha256(message) {
        const encoder = new TextEncoder();
        const data = encoder.encode(message);
        return window.crypto.subtle.digest('SHA-256', data);
    }

    /**
     * fetch the openid configuration for the issuer
     * @returns {Promise<any>}
     */
    static async getConfig(ISAM_DOMAIN) {
        if (ISAM_DOMAIN !== undefined && ISAM_DOMAIN !== null) {
            const response = await fetch(`${ISAM_DOMAIN}`);
            if (response !== null && response.status !== null && response.status === 200) {
                return response.json();
            }
        }
        throw new Error('Unable to retrieve authorization url metadata');
    }
}
